import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const animations = [
  'page-fade',
  'page-slide-left',
  'page-slide-right',
  'page-slide-up',
  'page-zoom',
];

function PageTransition({ children }) {
  const location = useLocation();
  const [anim, setAnim] = useState('');
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (prevPath.current !== location.pathname) {
      const pick = animations[Math.floor(Math.random() * animations.length)];
      setAnim(pick);
      prevPath.current = location.pathname;
      const timer = setTimeout(() => setAnim(''), 400);
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  return (
    <div className={`page-transition ${anim}`} key={location.pathname}>
      {children}
    </div>
  );
}

export default PageTransition;
